<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
	<form @submit.prevent="onSubmit">
		<smart-input
			v-model="form.name"
			:error="inputErrors.name"
			label="שם המרכז"
		/>
		<organizations-select
			v-if="isAdmin"
			v-model="form.organization_id"
		/>
		<media-gallery-preview
			v-model="form.media_id"
			:image-url="company.logo"
		/>
		<smart-input
			v-if="isAdmin"
			v-model="form.game"
			:error="inputErrors.game"
			style="direction: ltr"
			:rows="5"
			:textarea="true"
			label="מידע משחק"
			name="game"
		/>

		<v-select
			v-model="form.plan_name"
			:items="plans"
			label="תוכנית"
			single-line
		></v-select>

		<smart-input
			v-if="isAdmin"
			v-model="form.additional_games"
			type="number"
			label="כמות משחקים"
			name="game"
		/>
		<div class="form-group">
			<v-btn
				type="submit"
				color="success"
			>
				שמירה
			</v-btn>
		</div>
	</form>
</template>

<script>
import CompanyModule from "src/store/modules/Company.module";
import FormView from "src/mixins/FormView";
import OrganizationsSelect from "dev/view/organizations/OrganizationsSelect";
import MediaGalleryPreview from "../../packages/gallery/MediaGalleryPreview";

export default {
	name: "CompanyForm",
	components: { MediaGalleryPreview, OrganizationsSelect },
	props: [],
	data () {
		return {
			form: {
				name: null,
				organization_id: null,
				numofgames:0,
				plan_name: "",
			},
		};
	},
	mixins: [new FormView(CompanyModule, "company")],
	computed: {
		isNew () {
			return !this.company.id;
		},
		isAdmin () {
			return this.$store.getters.isAdmin;
		},
		plans() {
			return [
				{
					text: "ניסיון",
					value: "Free plan"
				},
				{
					text: "פרו",
					value: "Pro"
				}
			];
		}
	}
};
</script>

<style>

</style>
